import script from "./UpdateURL.vue?vue&type=script&lang=js"
export * from "./UpdateURL.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__